import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {LocalStorageService} from '../../../infrastructure/services/local-storage.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges {

  currentLang: string;

  constructor(private localStorageService: LocalStorageService,
              private router: Router) {
  }


  ngOnInit(): void {
    this.currentLang = this.localStorageService.getLang();
    this.localStorageService.languageChanged.subscribe(() => {
      this.currentLang = this.localStorageService.getLang();
    })
  }

  changeLang(lang: string) {
    this.localStorageService.setLang(lang);
  }


  ngOnChanges(changes: SimpleChanges): void {
  }

}
